import Constants from 'expo-constants';

export const brandForDomain = () => {
  if (!window.location.hostname) return '';

  if (window.location.hostname === 'localhost') {
    const brand = Constants.expoConfig?.extra?.brand;
    return brand === 'portal' ? 'portal' : 'leafdoctors';
  }

  if (window.location.hostname.indexOf('portal.leafdoctors.com.au') > -1) return 'portal';

  return 'leafdoctors';
};
